import React from 'react'
import CourseCard from '../../experience/details-card'
import useCourse from '../../../hooks/use-course'
import { Spinner } from 'react-bootstrap'
import Center from '../../common/center'

const Course = ({
    courseId
}) => {
    const { isBusy, course} = useCourse({ id: courseId })

    if (isBusy) {
        return (
            <Center><Spinner animation="border" variant="primary" /></Center>
        )
    }

    return (
        <CourseCard experience={course} key={course.id} disableUnenrollededDetails={true} />
    )
}

export default Course
